import { useEffect, useState } from "react";

import { useResolveWhitelabelbyRequestId } from "@/features/my-files/components/upload-files-modal/hooks/useResolveWhiteLabelByRequestId";
import { buildMyFilesUrl } from "@/features/shared/utils/buildMyFilesUrl";
import { getDefaultClientDeliveryMessage } from "@/features/shared/utils/getDefaultClientDeliveryMessage";
import { useGetRequest } from "@/hooks/useGetRequest";

interface UseClientDeliveryMessageReturn {
  isSendToChat: boolean;
  message: string;
  setIsSendToChat: (value: boolean) => void;
  setMessage: (value: string) => void;
}

export function useClientDeliveryMessage(
  requestId: number,
  isOpen: boolean,
): UseClientDeliveryMessageReturn {
  const { data } = useResolveWhitelabelbyRequestId(requestId);
  const { data: request } = useGetRequest(requestId);
  const [message, setMessage] = useState("");
  const [isSendToChat, setIsSendToChat] = useState(true);

  const brandId = request?.brandId;
  const projectId = request?.projectId;
  const requestType = request?.requestType;

  useEffect(() => {
    if (!isOpen) {
      setMessage("");
      setIsSendToChat(true);

      return;
    }

    if (typeof window === "undefined") {
      return;
    }

    setMessage(
      getDefaultClientDeliveryMessage(
        data?.domain,
        buildMyFilesUrl({ brandId, projectId, requestId, requestType }),
      ),
    );
    setIsSendToChat(true);
  }, [brandId, data?.domain, isOpen, projectId, requestId, requestType]);

  return {
    isSendToChat,
    message,
    setIsSendToChat,
    setMessage,
  };
}
